import React, { useContext, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { ConfigurationContext } from '../../context';
import LabelCustom from '../elements/LabelCustom';
import ValidateID from '../elements/ValidateID';
import { FaTimes } from "react-icons/fa";
import { useTranslation } from 'react-i18next';

import { shortenFileName } from '../../helpers/functions';

const WrapperStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    //height: 65px;
    order: ${props => props.order};
    width: ${props => props.is_uploading ? 'calc(100% - 50px)' : '100%'};
    .label_custom{
        margin-bottom: 5px;
    }
    >.error_message{
        margin-top: 3px;
        color: rgb(220,46,46);
    }
    >.inner{
        position: relative;
        display: flex;
        align-items: center;
        height: 44px;
        width: 100%;
        p{
            &.preloader{
                margin: 0;
                padding: 0;
                margin-right: 10px;
                font-size: 16px;
                line-height: 16px;
                font-weight: 800;
                background-color: rgba(103,97,234, 1);
                color: #ffffff;
                padding: 8px 6px 6px 6px;
            }
        }
        .bt_remove_file{
            display: flex;
            justify-self: flex-end;
            font-size: 18px;
            line-height: 18px;
            cursor: pointer;
            color: rgb(220,46,46);
            &:hover{
                color: rgba(103,97,234, 1);
            }
        }
        .button_select_file{
            display: flex;
            flex-direction: ${props => props.icon_side === "left" ? "row" : "row-reverse"};
            justify-content: center;
            align-items: center;
            padding: 10px 20px 10px 20px;
            height: 44px;
            background-color: rgba(103,97,234, 1);
            border: 1px solid rgba(103,97,234, 1);
            border-radius: 4px;
            box-sizing: border-box;
            cursor: pointer;
            font-size: 15px;
            line-height: 15px;
            color: #ffffff;
            font-weight: 600;
            &:hover{
                background-color: rgba(247,248,252, 1);
                border: 1px solid rgba(103,97,234, 1);
                color: rgba(103,97,234, 1);
            }
        }
        p{
            &.file_name{
                font-size: 15px;
                line-height: 15px;
                color: #484D63;
                font-weight: 600;
            }
        }
        >.prefix{
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: lightgray;
            font-size: 14px;
            line-height: 14px;
            font-weight: 600;
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
            padding: 0 10px;
        }
        >.icon{
            top: 11px;
            left: 10px;
            font-size: 23px;
            position: absolute;
            color: #645FF9;
        }
        input{
            position: relative;
            background-color: ${props => props.styles.background_color};
            border: 1px solid ${props => props.styles.border_color};
            border-radius: 6px;
            padding-left: ${props => props.icon ? "40px" : "10px" };
            padding-right: ${props => props.icon ? "40px" : "10px" };
            padding-top: 11px;
            padding-bottom: 11px;
            max-height: 44px;
            color: #484D63;
            font-size: 16px;
            &.with-prefix{
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
            :focus{
                outline: none !important;
                border-color: ${props => `rgb(${props.panColors.dots})`};
            }
            &[type="checkbox"]{
                width: 18px;
                height: 18px;
            }
            :disabled{
                opacity: 0.5;
            }
        }
    }
    >.help{
        font-size: 14px;
        margin-top: 5px;
        font-weight: 700;
        color: ${props => `rgb(${props.panColors.dark_gray})`};
        &.error{
            color: ${props => `rgb(${props.panColors.red})`};
        }
    }
    &.error{
        input{
            border: 2px solid ${props => `rgb(${props.panColors.red})`};
            :focus{
                outline: none !important;
                border-color: ${props => `rgb(${props.panColors.red})`};
            }
        }
    }
`




const InputSelectCustom = (props) => {

    const { t } = useTranslation();

    const { panColors } = useContext(ConfigurationContext);
    const fileInputRef = useRef(null);
    const [ selectedFile, setSelectedFile ] = useState(null);
    const [ errorMessage, setErrorMessage ] = useState(null);

    const { scope, 
            prefix = null,
            order, 
            name,
            label,
            onChange,
            onKeyDown,
            onKeyUp,
            className,
            type,
            value,
            help,
            placeholder,
            icon = null,
            label_icon = null,
            styles = null,
            disabled = false,
            isRequired = false,
            tooltip_content = null,
            haveError = null,
            validateStatus = null,
            setValidateStatus = null,
            index = null,
            isUploading,
            fileName, 
            setFileName,
            handleCancel } = props;


    const handleFileChange = (e) => {

        setErrorMessage(null);
        let isValid = true;
        const file = e.target.files[0];

        if (!file.type.startsWith('image/')) {
            isValid = false;
            setErrorMessage(t("El archivo debe ser una imagen"));
            return;
        }

        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        
        if (!allowedTypes.includes(file.type)) {
            isValid = false;
            setErrorMessage(t("Solo se permiten archivos JPG, JPEG o PNG"));
            return;
        }
        
        //setFileName(file.name);
        const size = ((file.size / 1024) / 1024);

        if (size > 1) {
            isValid = false;
            setErrorMessage(t("El archivo supera el tamano maximo permitido de 1MB"));
        }

        if(isValid){
            setSelectedFile(file);
            if (onChange) {
                onChange(name, file, index, e.keyCode);
            }
        }
    };

    const handleRemoveFile = () => {
        handleCancel();
        setSelectedFile(null);
        setFileName(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        if (onChange) {
            onChange(name, null, index, null);
        }
    };

    useEffect(() => {
        //console.log("🪼", scope, value)
        if(scope === 'edit'){
            setSelectedFile(value);
        }
        setFileName(value);

      return () => {}
    }, [value])
    

    return (
        <WrapperStyled 
            panColors={panColors}
            styles={styles}
            className={className} 
            icon={icon ? true : false}
            order={order}
            is_uploading={isUploading}
        >
            { label ? 
                <LabelCustom 
                    name={name}
                    label={label}
                    styles={styles}
                    label_icon={label_icon}
                    isRequired={isRequired}
                    tooltip_content={tooltip_content}
                />
            : "" }

            <div className="inner">
                {/* {name === "user_login" && <ValidateID status={validateStatus} setStatus={setValidateStatus} />}
                { prefix ? <div className="prefix">{prefix}</div> : "" } */}
                
                {/* {selectedFile ?
                    <p className='preloader'>100%</p>
                : "" } */}
                
                {/* Input file oculto */}
                <input
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    type="file"
                    name={name}
                    id={name}
                    onChange={handleFileChange}
                    disabled={disabled}
                />

                {/* Botón customizado para seleccionar archivo */}
                {(!fileName && !selectedFile) ?
                    <button
                        type="button"
                        onClick={() => fileInputRef.current && fileInputRef.current.click()}
                        disabled={disabled}
                        style={{ marginRight: "10px" }}
                        className='button_select_file'
                    >
                        { placeholder } {/* Seleccionar archivo */}
                    </button> 
                : "" }

                {/* Mostrar nombre del archivo */}
                <p className='file_name' style={{ margin: 0, flex: 1 }}>
                    { fileName ? shortenFileName(fileName, 15) : '' }
                    {/* {selectedFile ? selectedFile.name : placeholder || "Ningún archivo seleccionado"} */}
                </p>

                {/* Botón eliminar archivo */}
                {/*(selectedFile && !isUploading)*/(fileName || selectedFile) && (
                    <div
                        onClick={handleRemoveFile} 
                        className='bt_remove_file'>
                        <FaTimes />
                    </div>                        
                )}

                {icon ? 
                    <div className="icon">
                        {icon}
                    </div>
                : ""
                }
            </div>

            {errorMessage ?
                <small className="error_message">{ errorMessage }</small>
            : "" }

            { help ? <div className={`help${haveError ? " error" : ""}`}>{help}</div> : "" }
        </WrapperStyled>
    )
}

export default InputSelectCustom;



/*
const InputSelectCustom = (props) => {

    const { panColors } = useContext(ConfigurationContext);

    const { prefix = null,
            order, 
            name,
            label,
            onChange,
            onKeyDown,
            onKeyUp,
            className,
            type,
            value,
            help,
            placeholder,
            icon = null,
            label_icon = null,
            styles = null,
            disabled = false,
            isRequired = false,
            tooltip_content = null,
            haveError = null,
            validateStatus = null,
            setValidateStatus = null,
            index = null } = props;
    
    return (
        <WrapperStyled 
            panColors={panColors}
            styles={styles}
            className={className} 
            icon={icon ? true : false}
            order={order}
        >
            
            { label ? 
                <LabelCustom 
                    name={name}
                    label={label}
                    styles={styles}
                    label_icon={label_icon}
                    isRequired={isRequired}
                    tooltip_content={tooltip_content}
                />
            : "" }

            <div className="inner">
                
                {name === "user_login" && <ValidateID status={validateStatus} setStatus={setValidateStatus} />}
                { prefix ? <div className="prefix">{prefix}</div> : "" }
                <input 
                    className={`${prefix ? "with-prefix" : ""}`}
                    type={"file"} 
                    name={name} 
                    id={name} 
                    //value={value ? value : ""}
                    onChange={(e) => onChange ? onChange(name, e.target.value, index, e.keyCode) : null}
                    onKeyDown={(e) => onKeyDown ? onKeyDown(e.key, name, e.target.value) : null}
                    onKeyUp={(e) => onKeyUp ? onKeyUp(e, name, e.target.value) : null}
                    placeholder={placeholder}
                    disabled={disabled}
                />

                {icon ? 
                <div className="icon">
                    {icon}
                </div>
                : ""
                }
            </div>

            { help ? <div className={`help${haveError ? " error" : ""}`}>{help}</div> : "" }

        </WrapperStyled>

    )

}

export default InputSelectCustom;
*/